import EmptyListState from "../../components/EmptyListState/EmptyListState";
import SetEditor from "../../components/SetEditor/SetEditor";
import { PlusIcon } from "@heroicons/react/24/outline";
import { isEqual } from "lodash";

const ObjectID = require("bson-objectid");

const SetList = (props) => {
  const sets = props.sets;
  if (!sets) return;

  const handleAddNewSet = () => {
    const lastSet = sets.slice(-1)[0];
    const newId = ObjectID().toHexString();
    let newSet = {};
    if (!lastSet) {
      newSet = { _id: newId, weight: "", reps: "" };
    } else {
      newSet = { _id: newId, weight: lastSet.weight, reps: "" };
    }

    props.onSetsUpdated([...sets, newSet]);
  };

  const handleDeleteSet = (setId) => {
    const newSetsArray = sets.filter((set) => {
      return set._id !== setId;
    });

    props.onSetsUpdated(newSetsArray);
  };

  const handleSetDetailsUpdate = (updatedSet) => {
    let setsChanged = true;
    const newSetsArray = sets.map((set) => {
      if (set._id === updatedSet._id) {
        if (isEqual(updatedSet, set)) {
          setsChanged = false;
        }
        return updatedSet;
      } else {
        return set;
      }
    });

    if (setsChanged) {
      props.onSetsUpdated(newSetsArray);
    }
  };

  return (
    <div>
      <h2 className="pt-4 pb-1 px-2 block text-sm font-medium text-gray-700">
        Sets
      </h2>
      <div className="flex flex-col gap-y-4 px-2 py-1">
        {sets.length === 0 && (
          <EmptyListState
            title="No sets"
            message={"Start tracking by adding a new set."}
          />
        )}

        {sets.length > 0 &&
          sets.map((set, index) => {
            return (
              <SetEditor
                key={set._id}
                order={index + 1}
                exerciseSet={set}
                onDeleteSet={handleDeleteSet}
                onSetDetailsUpdate={handleSetDetailsUpdate}
              />
            );
          })}
      </div>
      <div className="py-4 px-2">
        <button
          type="button"
          className="relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-25"
          onClick={handleAddNewSet}
        >
          Add Set
          <span className="flex items-center pl-2">
            <PlusIcon className="h-5 w-5 text-white" aria-hidden="true" />
          </span>
        </button>
      </div>
    </div>
  );
};

export default SetList;
